export enum LotNumberUpdateOperation {
    INCREASE = 'INCREASE',
    DECREASE = 'DECREASE',
}
